<style scoped>
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}

.v-application .text-h3 {
  font-family: "Prompt", sans-serif !important;
  font-size: 18px !important;
  font-weight: bold;
}

.v-application .subtitle-1 {
  font-family: "Prompt", sans-serif !important;
}

.text-spacing {
  letter-spacing: 0px !important;
}

.v-application .white {
  border: #ccd0d9 solid 1px !important;
}

.text_div {
  margin-right: 20px;
  color: black;
  font-weight: bold;
}

.width_combo {
  max-width: 300px;
}

#map-container {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.pac-target-input {
  border: #b1b1b1 solid 1px;
  width: 450px;
  padding: 5px;
  border-radius: 5px;
  text-indent: 10px;
}

.handle {
  cursor: move;
}
</style>

<template>
  <div>
    <menuBar v-if="showMenu"></menuBar>
    <v-container fluid>
      <v-layout class="d-flex justify-space-between mb-2">
        <div class="text-h4 font-weight-black primary--text text-spacing ml-5" color="blue">
          กรอกข้อมูลลูกค้าละเอียด
        </div>
        <v-spacer></v-spacer>

        <!-- <v-btn color="white" elevation="0" large class="px-10 mr-4">ยกเลิก</v-btn> -->

        <v-btn color="white" elevation="0" large class="mr-4 px-10" v-if="!showMenu" @click="cancel()">ยกเลิก</v-btn>
        <div v-if="isEdit">
          <v-btn color="success" elevation="0" large dark class="mr-4 px-10" @click="edit_customer()">
            <div><v-icon left>mdi-plus</v-icon>แก้ไขข้อมูล</div>
          </v-btn>
        </div>

        <div v-else>
          <v-btn color="success" elevation="0" large dark class="mr-4 px-10" @click="add_customer()">
            <div v-if="showMenu"><v-icon left>mdi-plus</v-icon>ส่งข้อมูล</div>
            <div v-else><v-icon left>mdi-plus</v-icon>เพิ่มข้อมูล</div>
          </v-btn>
        </div>
      </v-layout>

      <!----  form modal ---------->

      <v-container fluid>
        <v-card shaped>
          <v-form ref="form" :lazy-validation="lazy" class="mx-4">
            <v-row dense>
              <v-col cols="12" lg="6">
                <v-col cols="12" lg="12">
                  <div class="text-h4 font-weight-black text-spacing ml-n3" color="blue">
                    ข้อมูลสถานบริการ
                  </div>
                  <v-divider></v-divider>
                </v-col>
                <v-row dense>
                  <v-col cols="12" lg="2" class="my-n2">
                    รหัสลูกค้า :
                    <v-text-field prepend-icon="mdi-account-key" :disabled="isEdit" color="black" outlined dense
                      v-model="Customer_Id"></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="6" class="my-n2">
                    รหัสอ้างอิง :
                    <v-text-field prepend-icon="mdi-file-key" color="black" outlined dense
                      v-model="cus_bill_id"></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="4" class="my-n2">
                    ประเภทผู้ติดต่อ:
                    <v-select prepend-icon="mdi-card-account-details" color="black" outlined dense :items="typeTax"
                      v-model="Contact_type"></v-select>
                  </v-col>
                  <!-- <v-col cols="12" lg="3">
                    สถานะ :
                    <v-select
                      color="black"
                      :items="Cstatus"
                      outlined
                      dense
                      
                    ></v-select>
                  </v-col> -->

                  <v-col cols="12" lg="4" class="my-n2">
                    กลุ่มลูกค้า :
                    <v-combobox prepend-icon="mdi-hospital-building" color="black" :items="groupHosp" outlined dense
                      @change="(evt) => Setgroup(evt)" v-model="Customer_Group"
                      :rules="[(v) => !!v || 'กรุณาเลือกกลุ่มลูกค้า']"></v-combobox>
                  </v-col>
                  <!--เลือกประเภท -->
                  <v-col cols="12" lg="4" class="my-n2">
                    <div v-if="this.Customer_Group == 'รพ.ใหญ่' ||
      this.Customer_Group == null
      ">
                      ประเภทโรงพยาบาล :
                      <v-select prepend-icon="mdi-hospital" color="black" outlined dense :items="data_ProductA"
                        @change="(evt) => SetpublicHosp(evt)" v-model="Customer_Type"></v-select>
                    </div>
                    <div v-if="this.Customer_Type == 'อื่น ๆ'" class="mt-n3">
                      ระบุ:
                      <v-text-field prepend-icon="mdi-hospital" dense outlined
                        v-model="Customer_Type_other"></v-text-field>
                    </div>

                    <div v-else-if="this.Customer_Group == 'รพ.เล็ก'">
                      ประเภทคลินิก :
                      <v-select prepend-icon="mdi-hospital" color="black" outlined dense :items="data_ProductB"
                        @change="(e) => SetOther(e)" v-model="Customer_Type"></v-select>
                      <div v-if="this.Customer_Type == 'อื่น ๆ'">
                        ระบุ :
                        <v-text-field prepend-icon="mdi-hospital" dense outlined
                          v-model="Customer_Type_other"></v-text-field>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" lg="4" class="my-n2">
                    ชื่อสถานพยาบาล/บริษัท :
                    <v-text-field prepend-icon="mdi-home-edit" color="black" outlined dense
                      v-model="Organizaion_Name"></v-text-field>
                  </v-col>
                  <!-- ccccccccccc -->
                  <v-col cols="12" lg="4" class="my-n2">
                    <div>
                      สำนักงานใหญ่/สาขา :
                      <v-select prepend-icon="mdi-home-city" dense outlined :items="offices"
                        @change="(e) => set_Office(e)" v-model="Customer_Branch"></v-select>
                    </div>

                    <div v-if="get_Office == true">
                      ระบุสาขา:
                      <v-text-field prepend-icon="mdi-home-city" dense outlined
                        v-model="Customer_Branch_Name"></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="12" lg="4" class="my-n2">
                    ชื่อสถานที่รับบริการ :
                    <v-textarea prepend-icon="mdi-home-edit" dense outlined v-model="Customer_Name"
                      rows="1"></v-textarea>
                  </v-col>
                  <v-col cols="12" lg="4" class="my-n2">
                    <strong class="red--text text--lighten-1">*</strong>เลขประจำตัวผู้เสียภาษี :
                    <v-text-field prepend-icon="mdi-id-card" dense outlined v-model="Customer_TaxID"></v-text-field>
                  </v-col>

                  <v-col cols="12" lg="4" class="my-n2">
                    ผู้มีอำนาจรับผิดชอบ :
                    <v-textarea prepend-icon="mdi-account-details" dense outlined v-model="Customer_OwnerName"
                      rows="1"></v-textarea>
                  </v-col>
                  <v-col cols="12" lg="4" class="my-n2">
                    ตำแหน่ง :
                    <v-text-field prepend-icon="mdi-book-account-outline" dense outlined
                      v-model="Customer_Position"></v-text-field>
                  </v-col>

                  <v-col cols="12" lg="4" class="my-n2">
                    โทรศัพท์ :
                    <v-text-field prepend-icon="mdi-card-account-phone" dense outlined
                      v-model="Customer_NewPhone"></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="4" class="my-n2">
                    โทรศัพท์มือถือ :
                    <v-text-field prepend-icon="mdi-cellphone" dense outlined v-model="Customer_Phone"></v-text-field>
                  </v-col>
                  <!-- /อะไรเนี้ย -->
                  <v-col cols="12" lg="4" class="my-n2">
                    facebook :
                    <v-text-field prepend-icon="mdi-facebook" dense outlined v-model="Customer_Facebook"></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="4" class="my-n2">
                    อีเมล์ :
                    <v-text-field prepend-icon="mdi-email" dense outlined v-model="Customer_Email"></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="4" class="my-n2">
                    line id :
                    <v-text-field prepend-icon="mdi-wechat" dense outlined v-model="Customer_Lidneid"></v-text-field>
                  </v-col>

                  <v-col cols="12" lg="8" class="my-n2">
                    ที่อยู่ :
                    <v-text-field prepend-icon="mdi-home-circle" outlined dense color="black"
                      v-model="Customer_Address"></v-text-field>
                  </v-col>

                  <v-col cols="12" lg="4" class="my-n4">
                    <addressinput-subdistrict v-model="Customer_Subdistrict" />
                  </v-col>
                  <v-col cols="12" lg="4" class="my-n4">
                    <addressinput-district v-model="Customer_District" />
                  </v-col>
                  <v-col cols="12" lg="4" class="my-n4">
                    <addressinput-province v-model="Customer_Province" />
                  </v-col>
                  <v-col cols="12" lg="4" class="mt-3">
                    <addressinput-zipcode v-model="Customer_Zipcode" />
                  </v-col>

                  <v-col cols="12" lg="8" class="mt-5">
                    รูปสถานประกอบการ :

                    <FileUpload ref="Use_Method_FileUpload"></FileUpload>

                    <div v-for="n in dataPick" :key="n">
                      <v-btn max-width="50px" block class="mb-1" @click="getDowloadPick(n.IMG_PATH, n.IMG_NAME)">
                        {{ n.IMG_NAME.substring(0, 20) + ".." }}
                      </v-btn>
                    </div>
                    <div class="text-center mb-5">
                      <v-dialog v-model="dialog" width="500">
                        <v-card>
                          <v-card-title class="headline grey lighten-2">
                            รูป
                          </v-card-title>
                          <v-card-text>
                            <v-img :src="imgUrl" class="white"></v-img>
                          </v-card-text>
                          <v-divider></v-divider>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" text @click="dialog = false">
                              ปิด
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </div>
                  </v-col>
                  <v-col cols="12" lg="4" class="mt-n3"> </v-col>
                  <v-col cols="12" lg="8" class="mt-n3">
                    เอกสารประกอบ :

                    <DocFileUpload ref="Use_Method_FileUpload_Document" />

                    <div v-for="n in dataDocument" :key="n">
                      <v-btn max-width="50px" block class="mb-1" @click="
      getDowloadFile(n.DOCUMENT_PATH, n.DOCUMENT_NAME)
      ">
                        {{ n.DOCUMENT_NAME.substring(0, 20) + ".." }}
                      </v-btn>
                    </div>
                  </v-col>

                  <v-col cols="12" lg="3" class="mt-n6">
                    <v-checkbox label="มัดจำประมูลงาน" v-model="is_depos" class="mr-n3"></v-checkbox>
                  </v-col>
                  <v-col cols="12" lg="3" class="mt-n2">
                    <v-text-field v-if="is_depos" dense label="จำนวน" v-model="depos_val" class="ml-n3"
                      type="number"></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="6" class="mt-n2">
                    <span class="mr-3" v-if="is_depos">วันที่วาง</span>
                    <date-picker v-if="is_depos" v-model="depos_date" class="mb-1" :format="momentFormat"></date-picker>
                  </v-col>
                  <v-col cols="12" lg="3" class="mt-n6">
                    <v-checkbox label="ยืมถัง" class="mr-n3" v-model="is_borrow"></v-checkbox>
                  </v-col>
                  <v-col cols="12" lg="3" class="mt-n2">
                    <v-text-field v-if="is_borrow" dense v-model="borrow_val" label="จำนวน" class="ml-n3"
                      type="number"></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="6" class="mt-n2">
                    <span class="mr-3" v-if="is_borrow">วันที่ยืม</span>
                    <date-picker v-if="is_borrow" v-model="borrow_date" class="mb-1"
                      :format="momentFormat"></date-picker>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" lg="6">
                <v-col cols="12" lg="12">
                  <div class="text-h4 font-weight-black text-spacing" color="blue">
                    ข้อมูลการเก็บขน
                  </div>
                  <v-divider></v-divider>
                </v-col>

                <v-col cols="12" lg="12">
                  <v-row class="">
                    <v-col cols="12" lg="5" class="mb-n8 mt-n6">
                      หน่วยรถ :
                      <v-select prepend-icon="mdi-truck-fast" :items="dataCar" item-text="CAR_NUMBER" outlined dense
                        v-model="car_numb"></v-select>
                    </v-col>
                    <v-col cols="12" lg="5" class="mb-n8 mt-n6">
                      วันที่เข้าเก็บ :
                      <date-picker color="black" class="mb-1 custom-datepicker" style="width: 100%" v-model="collect_dt"
                        :format="momentFormat"></date-picker>
                    </v-col>

                    <v-col cols="12" lg="4" class="my-n2">
                      วันที่เริ่มสัญญา
                      <date-picker color="black" class="mb-1 custom-datepicker" :format="momentFormat"
                        style="width: 100%" v-model="con_date"></date-picker>
                    </v-col>
                    <v-col cols="12" lg="4" class="my-n2">
                      ระยะเวลา
                      <span> (ปี) </span>
                      <v-autocomplete color="black" :items="contract_period"
                        :rules="[(v) => !!v || 'กรุณาเลือกระยะเวลา']" outlined dense v-model="con_period"
                        @change="c_period()"></v-autocomplete>
                    </v-col>
                    <v-col cols="12" lg="4" class="my-n2">
                      ครบกำหนด
                      <date-picker color="black" class="mb-1 custom-datepicker" disabled :format="momentFormat"
                        style="width: 100%" v-model="con_expire"></date-picker>
                    </v-col>
                    <v-col cols="12" lg="6" class="mt-n5">
                      ประการเก็บขน :
                      <v-select prepend-icon="mdi-note" outlined dense rows="1" :items="newType_collect"
                        @change="(evt) => newType_collectMethod(evt)" v-model="type_collect"></v-select>
                    </v-col>
                    <v-col cols="12" lg="6" class="mt-n5">
                      หมายเหตุ :
                      <v-textarea prepend-icon="mdi-note" outlined dense rows="1" v-model="nots"></v-textarea>
                    </v-col>

                    <v-col cols="12" lg="12" class="mt-n5">
                      <v-badge color="amber lighten-4" class="mr-5" left inline tile>วันเปิดทำการ</v-badge><v-badge
                        color="light-green lighten-1" left inline tile>วันเก็บขน</v-badge>

                      <Day ref="Use_Methods_Day" :fromPage="'add_detail_cus'" :zoneData="Zones" />
                    </v-col>
                  </v-row>
                </v-col>
              </v-col>

              <v-col cols="12" lg="12" class="mt-n5">
                <v-col cols="12" lg="12">
                  <div class="text-h4 font-weight-black text-spacing" color="blue">
                    ข้อมูลการบริการ
                  </div>
                  <v-divider></v-divider>
                </v-col>
                <v-row justify="center">
                  <v-col cols="12" lg="6">
                    <div class="subtitle-1 font-weight-bold">
                      ประเภทการจัดเก็บขยะ :
                    </div>
                    <v-select prepend-icon="mdi-notebook-multiple" :items="c_type"
                      @change="(event) => change_c_type(event)" outlined dense v-model="Customer_Category" color="black"
                      :rules="[(v) => !!v || 'กรุณาเลือกประเภทการจัดเก็บขยะ']"></v-select>
                  </v-col>
                  <v-col cols="12" lg="2" class="mt-5 mr-n15">
                    <v-checkbox label="ภาษีมูลค่าเพิ่ม" v-model="vat7"
                      @change="(evt) => checked_vat7(evt)"></v-checkbox>
                  </v-col>
                  <v-col cols="12" lg="1" class="mt-6 ml-n10">
                    <v-select v-if="isVat7" dense :items="se_vat7" style="width: 80px" class="mt-2 ml-2"
                      v-model="vat7_value"></v-select>
                  </v-col>
                  <v-col cols="12" lg="2" class="mt-5 mr-n8">
                    <v-checkbox label="หักภาษี ณ ที่จ่าย" v-model="vat3"
                      @change="(evt) => checked_vat3(evt)"></v-checkbox>
                  </v-col>
                  <v-col cols="12" lg="1" class="mt-6 ml-n13">
                    <v-select v-if="isVat3" dense :items="se_vat3" style="width: 80px" class="mt-2 ml-2"
                      v-model="vat3_value"></v-select>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" lg="11">
                    <v-simple-table dense>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left" style="width: 3%">ลำดับ</th>
                            <th class="text-left" style="width: 55%">
                              ชื่อสินค้า / รายละเอียด
                            </th>
                            <th class="text-left" style="width: 3%">จำนวน</th>
                            <th class="text-left" style="width: 10%">หน่วย</th>
                            <th class="text-left" style="width: 15%">
                              ราคาต่อหน่วย
                            </th>
                            <!-- <th class="text-left" style="width:12%">ราคารวม</th> -->
                            <th class="text-center" style="width: 2%"></th>
                          </tr>
                        </thead>
                        <draggable :list="product_list" tag="tbody" :move="onMove(product_list)">
                          <tr v-for="(item, index) in product_list" :key="index" class="handle">
                            <td>{{ index + 1 }}</td>
                            <td>
                              <v-menu offset-y>
                                <template v-slot:activator="{ on }">
                                  <v-text-field v-on="on" clearable placeholder="สินค้า" flat class="mt-2 mb-1" dense
                                    v-model="item.NAME" @keyup="search = $event.target.value"
                                    @click:clear="clearSearch()"></v-text-field>
                                </template>
                                <v-list style="max-height: 200px; overflow: auto">
                                  <v-list-item v-for="(item, i) in filteredItems" :key="i"
                                    @click="select_combo(index, item)">
                                    <v-list-item-title>{{
      item.NAME
    }}</v-list-item-title>
                                  </v-list-item>
                                </v-list>
                                <!-- <v-card>
                                  <v-divider></v-divider>
                                  <div class="pa-1" @click.stop>
                                    <v-btn
                                      text
                                      dark
                                      small
                                      color="primary"
                                      depressed
                                      :ripple="false"
                                      style="
                                        width: 100%;
                                        justify-content: start;
                                      "
                                    >
                                      <v-icon left>mdi-plus</v-icon>เพิ่มสินค้า
                                    </v-btn>
                                  </div>
                                </v-card> -->
                              </v-menu>
                              <v-textarea placeholder="รายละเอียด" dense outlined rows="1" row-height="5" auto-grow
                                class="my-n4" v-model="item.DETAIL"></v-textarea>
                            </td>
                            <td>
                              <v-text-field dense class="mt-3" type="number" v-model="item.AMOUT"
                                @keyup="changeUnit()"></v-text-field>
                            </td>
                            <td>
                              <v-text-field dense class="mt-3" v-model="item.UNIT"></v-text-field>
                            </td>
                            <td>
                              <v-text-field dense class="mt-3" v-model="item.PRICE"></v-text-field>
                            </td>

                            <td style="font-size: 1rem"></td>
                            <td>
                              <v-btn icon @click="delete_product(item)">
                                <v-icon>mdi-trash-can-outline</v-icon>
                              </v-btn>
                            </td>
                          </tr>
                        </draggable>

                        <v-spacer></v-spacer>
                      </template>
                    </v-simple-table>

                    <v-btn color="info" elevation="0" class="mt-5" @click="add_product()">
                      <v-icon left>mdi-plus</v-icon>เพิ่มแถวรายการ
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <v-row justify="end">
                <v-btn color="success" elevation="0" class="mt-5" @click="openmaplink()">
                  เปิดแผนที่
                </v-btn>
              </v-row>
              <v-col cols="12" lg="12" class="mb-10">
                ตำแหน่งบนแผนที่ :
                <div class="mt-5" style="height: 400px;z-index: -1;">
                  <l-map @click="addMarker" :zoom="zoom" :center="center" style="height: 80%; width: 100%" ref="myMap">
                    <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                    <l-marker :lat-lng="markerLatLng"></l-marker>
                    <l-control style="min-width: 1000px;" position="topright">
                      <div style="display: flex;">
                        <div style="width:100%">
                          <v-combobox item-value="display_name" @change="(evt) => searchLocationAndAddMarker(evt)"
                            item-text="display_name" :items="searchLocations" v-model="textsearch" solo
                            dense></v-combobox>
                        </div>
                        <!-- <div style="width:20%">
                          <v-btn color="primary" elevation="0"  dark class="ml-2"
                            @click="searchLocationAndAddMarker()">
                            <v-icon left>mdi-magnify</v-icon>ค้นหา
                          </v-btn>
                        </div> -->
                      </div>
                    </l-control>
                  </l-map>
                </div>
                <!-- <GmapAutocomplete
                  class="mb-3"
                  :placeholder="'ค้นหาสถานที่'"
                  :style="'width:900px;max-width:100% !important;'"
                  @place_changed="geolocateStart"
                  v-on:change="doClearLocation"
                  :options="{ fields: ['geometry'] }"
                ></GmapAutocomplete>
                <GmapMap
                  ref="mapRef"
                  :center="center"
                  :zoom="zoom"
                  map-type-id="terrain"
                  style="width: 100%; height: 300px"
                  @click="addMarker"
                  :options="mapStyle"
                >
                  <GmapMarker
                    :key="index"
                    v-for="(m, index) in markers"
                    :position="m"
                    :clickable="true"
                    :draggable="true"
                    @click="removeMarker(index)"
                  />
                </GmapMap> -->
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-container>
    </v-container>
  </div>
</template>
<script>
import menuBar from "../../components/menuBar";
import FileUpload from "../../components/FileUpload";
import DocFileUpload from "../../components/DocumentFileUpload";
import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
import { mapGetters, mapMutations, mapActions } from "vuex";
import draggable from "vuedraggable";
import Day from "../../components/Day";
import moment from "moment";
//AIzaSyAEVBQEOGBCGSmB_UrhGaAUPbtywC0s1TE   (google map key)
//sk.eyJ1Ijoic29vbnRvcm4yNiIsImEiOiJja2VtYzhzcGkxYjVtMnlwaXR3OWR0eDdjIn0.bOa1yFaYOOFLvHphcTpL6A
export default {
  components: {
    menuBar,
    VueTimepicker,
    FileUpload,
    Day,
    draggable,
    DocFileUpload,
  },
  data() {
    return {
      pre_route: "",
      // product_list: [],
      markers: [],
      searchLocations: [],
      textsearch: null,
      url: 'https://api.maptiler.com/maps/openstreetmap/{z}/{x}/{y}.jpg?key=ODQYjrfwMX2CleHUV2jQ',
      attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 3,
      center: [47.413220, -1.219482],
      markerLatLng: [18.787773664847744, 98.98561477661133],
      mapStyle: {
        styles: [
          {
            featureType: "poi",
            elementType: "labels.text",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "poi.business",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "transit",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
        ],
      },
      hosptype: [
        "โรงพยาบาลชุมชน",
        "โรงพยาบาลทั่วไป",
        "โรงพยาบาลศูนย์",
        "โรงพยาบาลส่งเสริมสุขภาพตำบล",
        "โรงพยาบาลเอกชน",
        "คลินิกสัตวแพทย์",
        "คลินิกเวชกรรม",
        "คลินิกทัวไป",
        "แล๊ป",
        "สหคลินิก",
        "คลินิกทันตกรรม",
        "สถานพักฟื้น",
        "อื่นๆ",
      ],
      panel: 0,
      branch: ["สำนักงานใหญ่", "สาขา"],
      lazy: false,
      showMenu: false,
      justify: ["start", "end", "center", "space-between", "space-around"],
      //test map leaftlet
      zoom: 13,
      center: { lat: 18.78726, lng: 98.98641 },
      markers: [],
      //Service Product type
      ServiceProduct_Price: [],
      ServiceProduct_weight: [],
      //Service Product type
      theLocation: "",
      curPlace: "",
      checkTSH: false,
      Cstatus: ["รอเสนอราคา", "ดำเนินการแล้ว", "ยกเลิก"],
      se_vat3: ["0.5%", "0.75%", "1%", "3%", "5%"],
      isVat3: false,
      se_vat7: ["7%", "10%"],
      isVat7: false,
      typeTax: ["นิติบุคคล", "บุคคลธรรมดา"],
      momentFormat: {
        // Date to String
        stringify: (date) => {
          return date
            ? moment(date).add(543, "year").locale("th").format("LL")
            : "";
        },
        // String to Date
        parse: (value) => {
          return value ? moment(value, "LL").toDate() : null;
        },
      },
      contract_period: ["1", "2", "3", "4"],
      modal: false,
      Zones: [],
      dialog: false,
      dialog_doc: false,
      serviceB: false,
      serviceA: "รพ.ใหญ่",
      carGo: false,
      data_Products: [],
      data_ProductB: [
        "เวชกรรมความงาม",
        "เวชกรรมทั่วไป.",
        "ทันตกรรม",
        "สัตวแพทย์",
        "อื่น ๆ",
      ],
      data_ProductA: [
        "โรงพยาบาลรัฐ",
        "โรงพยาบาลเอกชน",
        "รพ.สต.",
        "แลป",
        "อื่น ๆ",
      ],
      isDepos: false,
      isBorrow: false,
      groupHosp: ["รพ.ใหญ่", "รพ.เล็ก"],
      servicePublic: "",
      data_servicePublic: ["โรงพยาบาลรัฐบาล", "โรงพยาบาลเอกชน"],
      serviceOther: "",
      GetcarGo: false,
      countRow: 1,
      isEdit: false,
      offices: ["สำนักงานใหญ่", "สาขา"],
      get_Office: false,
      dataCar: [],
      c_type: ["รายเดือน", "รายปี", "คิดตามกิโลกรัม"],
      newType_collect: ["เก็บรายสัปดาห์", "เก็บรายเดือน/1", "เก็บรายเดือน/2"],
      type_collect: "",
      imgUrl: "",
      haveFile: false,
      dataPick: "",
      dataDocument: "",
    };
  },

  computed: {
    ...mapGetters({
      getProduct: "CustomerDetail/GET_PRODUCT",
      getCollectDays: "CustomerDetail/GET_DAYS",
      getCustomer: "CustomerDetail/GET_CUSTOMER",
      GET_IS_EDIT: "CustomerDetail/IS_EDIT",
    }),
    con_date: {
      get() {
        return this.getCustomer.CONTRACT_START_DATE == null
          ? ""
          : new Date(this.getCustomer.CONTRACT_START_DATE);
      },
      set(value) {
        if (value != null) {
          this.SET_ELEMENT({ key: "CONTRACT_START_DATE", value: value });
        } else {
          this.SET_ELEMENT({ key: "CONTRACT_START_DATE", value: "" });
        }
      },
    },
    con_period: {
      get() {
        return this.getCustomer.CONTRACT_PERIOD;
      },
      set(value) {
        this.SET_ELEMENT({ key: "CONTRACT_PERIOD", value: value });
      },
    },
    con_expire: {
      get() {
        return this.getCustomer.CONTRACT_END_DATE == null
          ? ""
          : new Date(this.getCustomer.CONTRACT_END_DATE);
      },
      set(value) {
        this.SET_ELEMENT({ key: "CONTRACT_END_DATE", value: value });
      },
    },
    is_depos: {
      get() {
        this.isDepos = this.getCustomer.ISDEPOSIT == 1 ? true : false;
        return this.getCustomer.ISDEPOSIT;
      },
      set(value) {
        this.SET_ELEMENT({
          key: "ISDEPOSIT",
          value: value,
        });
      },
    },
    depos_val: {
      get() {
        return this.getCustomer.DEPOSIT_VALUE;
      },
      set(value) {
        this.SET_ELEMENT({
          key: "DEPOSIT_VALUE",
          value: value,
        });
      },
    },
    depos_date: {
      get() {
        return this.getCustomer.DEPOSIT_DATE == null
          ? ""
          : new Date(this.getCustomer.DEPOSIT_DATE);
      },
      set(value) {
        if (value != null) {
          this.SET_ELEMENT({ key: "DEPOSIT_DATE", value: value });
        } else {
          this.SET_ELEMENT({ key: "DEPOSIT_DATE", value: "" });
        }
      },
    },
    is_borrow: {
      get() {
        this.isBorrow = this.getCustomer.ISBORROW == 1 ? true : false;
        return this.getCustomer.ISBORROW;
      },
      set(value) {
        this.SET_ELEMENT({
          key: "ISBORROW",
          value: value,
        });
      },
    },
    borrow_val: {
      get() {
        return this.getCustomer.BORROW_VALUE;
      },
      set(value) {
        this.SET_ELEMENT({
          key: "BORROW_VALUE",
          value: value,
        });
      },
    },
    borrow_date: {
      get() {
        return this.getCustomer.BORROW_DATE == null
          ? ""
          : new Date(this.getCustomer.BORROW_DATE);
      },
      set(value) {
        if (value != null) {
          this.SET_ELEMENT({ key: "BORROW_DATE", value: value });
        } else {
          this.SET_ELEMENT({ key: "BORROW_DATE", value: "" });
        }
      },
    },
    Customer_Category: {
      get() {
        return this.getCustomer.CONTRACT_CATEGORY;
      },
      set(value) {
        this.SET_ELEMENT({ key: "CONTRACT_CATEGORY", value: value });
      },
    },
    collect_zone: {
      get() {
        return this.getCustomer.COLLECT_ZONE;
      },
      set(value) {
        this.SET_ELEMENT({ key: "COLLECT_ZONE", value: value });
      },
    },
    collect_dt: {
      get() {
        return this.getCustomer.COLLECT_DATE == null
          ? ""
          : new Date(this.getCustomer.COLLECT_DATE);
      },
      set(value) {
        if (value != null) {
          this.SET_ELEMENT({ key: "COLLECT_DATE", value: value });
        } else {
          this.SET_ELEMENT({ key: "COLLECT_DATE", value: "" });
        }
      },
    },
    cus_bill_id: {
      get() {
        return this.getCustomer.BILL_ID;
      },
      set(value) {
        this.SET_ELEMENT({ key: "BILL_ID", value: value });
      },
    },
    Customer_Type_other: {
      get() {
        return this.getCustomer.CUSTOMER_TYPE_OTHER;
      },
      set(value) {
        this.SET_ELEMENT({ key: "CUSTOMER_TYPE_OTHER", value: value });
      },
    },
    Customer_Name: {
      get() {
        return this.getCustomer.CUSTOMER_NAME;
      },
      set(value) {
        this.SET_ELEMENT({ key: "CUSTOMER_NAME", value: value });
      },
    },
    Customer_Type: {
      get() {
        return this.getCustomer.CUSTOMER_TYPE;
      },
      set(value) {
        this.SET_ELEMENT({
          key: "CUSTOMER_TYPE",
          value: value,
        });
      },
    },
    Customer_ฺBranch: {
      get() {
        return this.getCustomer.CUSTOMER_BRANCH;
      },
      set(value) {
        this.SET_ELEMENT({
          key: "CUSTOMER_BRANCH",
          value: value,
        });
      },
    },
    Customer_Address: {
      get() {
        return this.getCustomer.CUSTOMER_ADDRESS;
      },
      set(value) {
        this.SET_ELEMENT({
          key: "CUSTOMER_ADDRESS",
          value: value,
        });
      },
    },
    Customer_Subdistrict: {
      get() {
        return this.getCustomer.CUSTOMER_SUBDISTRICT;
      },
      set(value) {
        this.SET_ELEMENT({
          key: "CUSTOMER_SUBDISTRICT",
          value: value,
        });
      },
    },
    Customer_District: {
      get() {
        return this.getCustomer.CUSTOMER_DISTRICT;
      },
      set(value) {
        this.SET_ELEMENT({
          key: "CUSTOMER_DISTRICT",
          value: value,
        });
      },
    },
    Customer_Province: {
      get() {
        return this.getCustomer.CUSTOMER_PROVINCE;
      },
      set(value) {
        this.SET_ELEMENT({
          key: "CUSTOMER_PROVINCE",
          value: value,
        });
      },
    },
    Customer_Zipcode: {
      get() {
        return this.getCustomer.CUSTOMER_ZIPCODE;
      },
      set(value) {
        this.SET_ELEMENT({
          key: "CUSTOMER_ZIPCODE",
          value: value,
        });
      },
    },
    //ORGANIZATION_NAME
    Organizaion_Name: {
      get() {
        return this.getCustomer.ORGANIZATION_NAME;
      },
      set(value) {
        this.SET_ELEMENT({
          key: "ORGANIZATION_NAME",
          value: value,
        });
      },
    },
    Customer_OwnerName: {
      get() {
        return this.getCustomer.PROVIDER_NAME;
      },
      set(value) {
        this.SET_ELEMENT({
          key: "PROVIDER_NAME",
          value: value,
        });
      },
    },
    Customer_TaxID: {
      get() {
        return this.getCustomer.CUSTOMER_TAX_ID;
      },
      set(value) {
        this.SET_ELEMENT({
          key: "CUSTOMER_TAX_ID",
          value: value,
        });
      },
    },
    Customer_Position: {
      get() {
        return this.getCustomer.PROVIDER_POSITION;
      },
      set(value) {
        this.SET_ELEMENT({
          key: "PROVIDER_POSITION",
          value: value,
        });
      },
    },
    Customer_Phone: {
      get() {
        return this.getCustomer.PROVIDER_PHONE;
      },
      set(value) {
        this.SET_ELEMENT({
          key: "PROVIDER_PHONE",
          value: value,
        });
      },
    },
    Customer_NewPhone: {
      get() {
        return this.getCustomer.PROVIDER_NEWPHONE;
      },
      set(value) {
        this.SET_ELEMENT({
          key: "PROVIDER_NEWPHONE",
          value: value,
        });
      },
    },
    Customer_Email: {
      get() {
        return this.getCustomer.PROVIDER_EMAIL;
      },
      set(value) {
        this.SET_ELEMENT({
          key: "PROVIDER_EMAIL",
          value: value,
        });
      },
    },
    Customer_Lidneid: {
      get() {
        return this.getCustomer.PROVIDER_LINE_ID;
      },
      set(value) {
        this.SET_ELEMENT({
          key: "PROVIDER_LINE_ID",
          value: value,
        });
      },
    },
    Customer_Facebook: {
      get() {
        return this.getCustomer.PROVIDER_FACEBOOK;
      },
      set(value) {
        this.SET_ELEMENT({
          key: "PROVIDER_FACEBOOK",
          value: value,
        });
      },
    },
    Customer_Id: {
      get() {
        return this.getCustomer.NEWCUSTOMER_ID;
      },
    },
    Contact_type: {
      get() {
        return this.getCustomer.CONTACT_TYPE;
      },
      set(value) {
        this.SET_ELEMENT({
          key: "CONTACT_TYPE",
          value: value,
        });
      },
    },
    Customer_Group: {
      get() {
        return this.getCustomer.CUSTOMER_GROUP;
      },
      set(value) {
        this.SET_ELEMENT({
          key: "CUSTOMER_GROUP",
          value: value,
        });
      },
    },
    Customer_Branch: {
      get() {
        return this.getCustomer.CUSTOMER_BRANCH;
      },
      set(value) {
        this.SET_ELEMENT({
          key: "CUSTOMER_BRANCH",
          value: value,
        });
      },
    },
    Customer_Branch_Name: {
      get() {
        return this.getCustomer.CUSTOMER_BRANCH_NAME;
      },
      set(value) {
        this.SET_ELEMENT({
          key: "CUSTOMER_BRANCH_NAME",
          value: value,
        });
      },
    },
    vat7: {
      get() {
        this.isVat7 = this.getCustomer.ISVAT == 1 ? true : false;
        return this.getCustomer.ISVAT;
      },
      set(value) {
        this.SET_ELEMENT({
          key: "ISVAT",
          value: value,
        });
      },
    },
    vat3: {
      get() {
        this.isVat3 = this.getCustomer.ISVAT2 == 1 ? true : false;
        return this.getCustomer.ISVAT2;
      },
      set(value) {
        this.SET_ELEMENT({
          key: "ISVAT2",
          value: value,
        });
      },
    },
    vat7_value: {
      get() {
        return this.getCustomer.VAT_VALUE;
      },
      set(value) {
        this.SET_ELEMENT({
          key: "VAT_VALUE",
          value: value,
        });
      },
    },
    vat3_value: {
      get() {
        return this.getCustomer.VAT_VALUE2;
      },
      set(value) {
        this.SET_ELEMENT({
          key: "VAT_VALUE2",
          value: value,
        });
      },
    },
    car_numb: {
      get() {
        return this.getCustomer.CAR_NUMBER;
      },
      set(value) {
        this.SET_ELEMENT({
          key: "CAR_NUMBER",
          value: value,
        });
      },
    },
    nots: {
      get() {
        return this.getCustomer.NOTE;
      },
      set(value) {
        this.SET_ELEMENT({
          key: "NOTE",
          value: value,
        });
      },
    },
    filteredItems() {
      let searchRegExp = new RegExp(this.search, "gi");
      return this.data_Products.filter((item) => {
        if (!this.search) {
          return this.data_Products;
        } else {
          return searchRegExp.test(item.NAME);
        }
      });
    },
    product_list: {
      get() {
        return this.getProduct;
      },
      set() { },
    },
  },
  watch: {
    cus_bill_id: {
      handler: function (val, oldVal) { },
    },
  },
  mounted() {
    // require.context()

    this.list_customer_file();
    //this.initLocation()
    // this.$refs.mapRef.$mapPromise.then((map) => {

    // });
    console.log([this.getCustomer.LATS,this.getCustomer.LONGS])
    this.markerLatLng = [this.getCustomer.LATS,this.getCustomer.LONGS];
    this.center = [this.getCustomer.LATS, this.getCustomer.LONGS ];

  },
  created() {
    if (this.$route.name == "register-newCustomer") {
      this.showMenu = true;
    } else {
      this.showMenu = false;
    }
    this.isEdit = this.GET_IS_EDIT;
    this.getDataProduct();
    this.getDataCar();
    this.initZone();
    this.getListPick();
    this.getListDocument();
    this.get_collecttype();
    // this.product_list = this.getProduct
  },
  methods: {
    ...mapMutations({
      SET_ELEMENT: "CustomerDetail/SET_ELEMENT",
      SET_PRODUCT_LIST: "CustomerDetail/SET_PRODUCT_LIST",
      LOADER: "Drawer/SET_LOADER",
    }),
    initZone() {
      this.$token_api
        .get("/list-all-zone")
        .then((response) => {
          this.Zones = response.data.data;
        })
        .catch((err) => { });
    },
    onMove(item) {
      this.SET_PRODUCT_LIST(item);
      // this.product_list = item;
      //api update
    },
    generateZone() {
      this.collect_zone =
        "Zone-" +
        this.getCustomer.CUSTOMER_GROUP +
        "-" +
        this.getCustomer.CUSTOMER_PROVINCE;
    },
    select_combo(i, item) {
      this.product_list[i].PID = item.PID;
      this.product_list[i].NAME = item.NAME;
      this.product_list[i].UNIT = item.UNIT;
      this.product_list[i].DETAIL = item.DETAIL;
      this.product_list[i].PRICE = item.PRICE;

      let product = this.getProduct;
      var valueArr = product.map(function (x) {
        return x.PID;
      });
      var isDuplicate = valueArr.some(function (item, idx) {
        return valueArr.indexOf(item) != idx;
      });
      if (isDuplicate) {
        this.$swal({
          title: "กรุณากรอกข้อมูลใหม่",
          text: "พบรายการสินค้าซ้ำ",
          timer: 2000,
          icon: "warning",
        }).then((res) => {
          this.$store.dispatch("CustomerDetail/remove_product_list", item);
        });
      }
    },
    list_customer_file() {
      //console.log(this.getCustomer.NEWCUSTOMER_ID)
      // this.$token_api
      //   .post("/list-customer-file", { CUSTOMER_ID: this.NEWCUSTOMER_ID })
      //   .then((response) => {
      //     console.log(response.data.data);
      //     //require.context()
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //   });
    },
    geolocateStart(event) {
      let laglng = event.geometry.location;
      let position = {
        lat: laglng.lat(),
        lng: laglng.lng(),
      };
      this.$refs.mapRef.$mapPromise.then((map) => {
        map.panTo(position);
      });
      // this.markers.push(position);
      let ml = this.markers.length;
      //console.log(ml);
      if (ml >= 0 && ml < 1) {
        this.markers.push(position);
      } else {
        this.markers = [];
        this.markers.push(position);
      }
      // console.log(event.geometry.location)
    },
    cancel() {
      let _from = this.pre_route;
      if (_from) {
        window.location.href = `${this.$global_link}${_from.path}`;
      } else {
        window.location.href = `${this.$global_link}`;
      }
    },
    doClearLocation() {
      this.theLocation = "";
      this.curPlace = "";
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    removeMarker(index) {
      this.markers.splice(index, 1);
    },
    addMarker(event) {
      let pos = event.latlng
      let position = {
        lat: pos.lat,
        lng: pos.lng,
      };
      this.markerLatLng = [pos.lat, pos.lng]
      let ml = this.markers.length;
      // console.log(ml);
      if (ml >= 0 && ml < 1) {
        this.markers.push(position);
      } else {
        this.markers = [];
        this.markers.push(position);
      }

    },
    initLocation() {

      const success = (position) => {
        const latitude = position.coords.latitude
        const longitude = position.coords.longitude
        this.center = [latitude, longitude]
        this.markerLatLng = [latitude, longitude]
      }
      const error = (err) => {
        e.log(error)
      }
      navigator.geolocation.getCurrentPosition(success, error)

    },
    searchLocationAndAddMarker(evt) {
      // Encode ชื่อสถานที่เพื่อให้เหมาะสมกับ URL
      let searchtxt = this.textsearch
      let searchobj = typeof evt == 'string' ? {} : evt
      let encodedLocationName = ""
      if (typeof searchtxt == 'string') {
        encodedLocationName = encodeURIComponent(searchtxt);
      }
      axios.get(`https://nominatim.openstreetmap.org/search?format=json&q=${encodedLocationName}`)
        .then(response => {
          const data = response.data;
          if (data.length > 0) {

            this.searchLocations = data

          } else {
            this.searchLocations = []
          }
        })
        .catch(error => console.log(error));
      if (searchobj.hasOwnProperty('lat')) {

        this.center = [searchobj.lat, searchobj.lon]
        this.markerLatLng = [searchobj.lat, searchobj.lon]
        let position = {
          lat: parseFloat(searchobj.lat),
          lng: parseFloat(searchobj.lon),
        };
        let ml = this.markers.length;
        // console.log(ml);
        if (ml >= 0 && ml < 1) {
          this.markers.push(position);
        } else {
          this.markers = [];
          this.markers.push(position);
        }

      }
    },
    clearSearch() {
      this.search = "";
    },
    //insert database
    check_day() {
      let x = this.getCollectDays;

      for (const key in x) {
        if (Object.hasOwnProperty.call(x, key)) {
          if (x[key].TRANSPORT == 0) {
          } else {
            return true;
          }
        }
      }
    },

    async add_customer() {
      let data_cus = this.getCustomer;
      let collect_time = this.getCollectDays;
      let data_product = this.getProduct;
      let con_start = this.getCustomer.CONTRACT_START_DATE;
      let con_end = this.getCustomer.CONTRACT_END_DATE;
      this.LOADER(true);
      if (!data_cus.COLLECT_DATE) {
        this.$swal("ข้อมูลไม่ครบ", "กรุณากรอกวันที่เข้าเก็บ", "warning");
        this.LOADER(false);
      } else if (!data_cus.CONTRACT_START_DATE) {
        this.$swal("ข้อมูลไม่ครบ", "กรุณากรอกวันที่เริ่มสัญญา", "warning");
        this.LOADER(false);
      } else if (this.check_day() != true) {
        this.$swal("เกิดข้อผิดพลาด", "กรุณาเลือกวันเก็บขน", "warning");
        this.LOADER(false);
      } else {
        if (this.$refs.form.validate()) {
          if (this.type_collect == "") {
            this.$swal("ข้อมูลไม่ครบ", "กรุณาเลือกประเภทการเก็บขน", "warning");
            this.LOADER(false);
          } else {
            await this.$refs.Use_Method_FileUpload.onUpload(
              this.getCustomer.NEWCUSTOMER_ID
            );
            await this.$refs.Use_Method_FileUpload_Document.onUpload(
              this.getCustomer.NEWCUSTOMER_ID
            );
            this.SET_ELEMENT({
              key: "MEMO",
              value:
                this.getCustomer.NEWCUSTOMER_ID +
                "-เริ่มทำสัญญา " +
                moment(con_start).add(543, "Y").format("DD/MM/YY") +
                " - " +
                moment(con_end)
                  .add(543, "Y")
                  .subtract(1, "days")
                  .format("DD/MM/YY"),
            });
            //console.log(this.type_collect);
            this.$token_api
              .post("/update-Customer", {
                CUS_DATA: data_cus,
                PRODUCT: data_product,
                COLLECT_TIME: collect_time,
                COLLECT_TYPR:
                  this.type_collect == "เก็บรายสัปดาห์"
                    ? "W"
                    : this.type_collect == "เก็บรายเดือน/1"
                      ? "M1"
                      : "M2",
              })
              .then((response) => {
                this.$swal({
                  title: "สำเร็จ",
                  text: "อัพเดทข้อมูลสำเร็จ",
                  icon: "success",
                  timer: 2000,
                }).then(() => {
                  this.LOADER(false);
                  window.location.href = `${this.$global_link}/newCustomer/confirm-newCustomer`;
                });
                this.$refs.form.reset();
              })
              .catch((error) => {
                console.log(error);
                this.$swal({
                  title: "เกิดข้อผิดพลาด",
                  text: "กรุณาลองใหม่อีกครั้ง",
                  icon: "error",
                  timer: 2000,
                });
                this.LOADER(false);
              });
          }
        } else {
          this.$swal("ข้อมูลไม่ครบ", "กรุณากรอกข้อมูลให้ครบถ้วน", "warning");
          this.LOADER(false);
        }
      }
    },
    async edit_customer() {
      let data_cus = this.getCustomer;
      let collect_time = this.getCollectDays;
      let data_product = this.getProduct;
      let con_start = this.getCustomer.CONTRACT_START_DATE;
      let con_end = this.getCustomer.CONTRACT_END_DATE;
      this.LOADER(true);
      if (!data_cus.COLLECT_DATE) {
        this.$swal("ข้อมูลไม่ครบ", "กรุณากรอกวันที่เข้าเก็บ", "warning");
        this.LOADER(false);
      } else if (!data_cus.CONTRACT_START_DATE) {
        this.$swal("ข้อมูลไม่ครบ", "กรุณากรอกวันที่เริ่มสัญญา", "warning");
        this.LOADER(false);
      } else if (this.check_day() != true) {
        this.$swal("เกิดข้อผิดพลาด", "กรุณาเลือกวันเก็บขน", "warning");
        this.LOADER(false);
      } else {
        if (this.$refs.form.validate()) {
          if (this.type_collect == "") {
            this.$swal("ข้อมูลไม่ครบ", "กรุณาเลือกประเภทการเก็บขน", "warning");
            this.LOADER(false);
          } else {
            await this.$refs.Use_Method_FileUpload.onUpload(this.Customer_Id);
            await this.$refs.Use_Method_FileUpload_Document.onUpload(
              this.Customer_Id
            );
            this.SET_ELEMENT({
              key: "MEMO",
              value:
                this.getCustomer.NEWCUSTOMER_ID +
                "-เริ่มทำสัญญา " +
                moment(con_start).add(543, "Y").format("DD/MM/YY") +
                " - " +
                moment(con_end)
                  .add(543, "Y")
                  .subtract(1, "days")
                  .format("DD/MM/YY"),
            });

            this.$token_api
              .post("/edit-customer", {
                CUS_DATA: data_cus,
                PRODUCT: data_product,
                COLLECT_TIME: collect_time,
                COLLECT_TYPR:
                  this.type_collect == "เก็บรายสัปดาห์"
                    ? "W"
                    : this.type_collect == "เก็บรายเดือน/1"
                      ? "M1"
                      : "M2",
              })
              .then((response) => {
                this.$swal({
                  title: "สำเร็จ",
                  text: "อัพเดทข้อมูลสำเร็จ",
                  icon: "success",
                  timer: 2000,
                }).then(() => {
                  this.LOADER(false);
                  window.location.href = `${this.$global_link}/newCustomer/all-newCustomer`;
                });
                this.$refs.form.reset();
              })
              .catch((error) => {
                this.LOADER(false);
                this.$swal("เกิดข้อผิดพลาด", "กรุณาลองใหม่อีกครั้ง", "error");
              });
          }
        } else {
          this.$swal("เกิดข้อผิดพลาด", "กรุณากรอกข้อมูลให้ครบถ้วน", "error");
          this.LOADER(false);
        }
      }
    },
    checked_vat3(item) {
      this.isVat3 = item;
    },
    checked_vat7(item) {
      this.isVat7 = item;
    },

    getDataProduct() {
      this.$token_api
        .get("/list-product")
        .then((response) => {
          // console.log(response.data.data);
          this.data_Products = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    Setgroup(e) {
      //console.log(e);
      if (e == "รพ.ใหญ่") {
        this.serviceA = e;
      } else if (e == "รพ.เล็ก") {
        this.serviceA = e;
      }
    },
    SetpublicHosp(e) {
      if (e == "รพ.เล็ก") {
        this.servicePublic = e;
      } else if (e == "อื่น ๆ") {
        this.servicePublic = e;
      } else {
        this.servicePublic = "";
      }
    },
    c_period() {
      let con_start = this.getCustomer.CONTRACT_START_DATE;
      let con_peroid = this.getCustomer.CONTRACT_PERIOD;

      this.SET_ELEMENT({
        key: "CONTRACT_END_DATE",
        value: new Date(
          moment(con_start)
            .add(parseInt(con_peroid), "Y")
            .subtract(1, "days")
            .format("YYYY-MM-DD")
        ),
      });
    },
    SetOther(e) {
      if (e == "อื่น ๆ") {
        this.serviceOther = e;
      } else {
        this.serviceOther = "";
      }
    },
    set_Office(e) {
      if (e == "สาขา") {
        this.get_Office = true;
      } else {
        this.get_Office = false;
      }
    },
    SetcarGo(e) {
      this.GetcarGo = e;
    },
    countaddRow() {
      this.countRow++;
    },
    countsubRow() {
      if (this.countRow > 1) this.countRow--;
    },
    change_c_type(e) {
      let cus_id = this.getCustomer.NEWCUSTOMER_ID;
      if (this.isEdit) {
        this.LOADER(true);
        this.$token_api
          .delete("/delete-customer-product-all", { data: { CUS_ID: cus_id } })
          .then((response) => {
            this.insert_c_product(e);
            this.LOADER(false);
          })
          .catch((err) => {
            this.LOADER(false);
          });
      } else {
        this.insert_c_product(e);
      }

      //console.log(this.product_list)
    },
    newType_collectMethod(e) {
      this.type_collect = e;
    },
    insert_c_product(e) {
      if (e == "รายเดือน") {
        this.$guest_api
          .post("/list-product-by-category", {
            category: e,
          })
          .then((res) => {
            this.SET_PRODUCT_LIST(res.data.data);
            //  this.product_list = res.data.data
            // this.cus_bill_id = "M-" + this.getCustomer.COLLECT_ZONE;
          });
      } else if (e == "รายปี") {
        this.$guest_api
          .post("/list-product-by-category", {
            category: e,
          })
          .then((res) => {
            this.SET_PRODUCT_LIST(res.data.data);
            // this.product_list = res.data.data
            // this.cus_bill_id = "Y-" + this.getCustomer.COLLECT_ZONE;
          });
      } else if (e == "คิดตามกิโลกรัม") {
        this.$guest_api
          .post("/list-product-by-category", { category: e })
          .then((res) => {
            this.SET_PRODUCT_LIST(res.data.data);
            // this.product_list = res.data.data
            //this.cus_bill_id = "K-" + this.getCustomer.COLLECT_ZONE;
          });
      } else {
      }
    },
    add_product() {
      this.$store.dispatch("CustomerDetail/add_product_list", {
        INDEX: 0,
        NAME: "",
        DETAIL: "",
        AMOUT: 1,
        UNIT: "",
        PRICE: 0,
        TOTAL_PRICE: 0,
      });
    },
    delete_product(item) {
      if (this.isEdit) {
        this.$swal({
          title: "ต้องการลบสินค้าหรือไม่",
          text: `กรุณากดปุ่ม "ยีนยัน" เพื่อลบสินค้า`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
        }).then((result) => {
          if (result.value) {
            this.$store.dispatch("CustomerDetail/remove_product_list", item);
            this.$token_api
              .delete("/delete-customer-product-by-id", {
                data: { PRO_ID: item.PRO_ID },
              })
              .then((response) => {
                // this.$store.dispatch("CustomerDetail/remove_product_list",item);
              })
              .catch((err) => {
                console.log(err);
              });
          }
        });
      } else {
        this.$store.dispatch("CustomerDetail/remove_product_list", item);
      }
    },
    getDataCar() {
      this.$token_api
        .get("/list-car-data")
        .then((response) => {
          // console.log(response.data.data)
          this.dataCar = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getDowloadPick(linkFile, nameFile) {
      //console.log(this.Customer_Id);
      console.log(linkFile);
      console.log(nameFile);
      this.dialog = true;
      console.log(this.dialog);
      this.$download_api
        .post(`/download-customer-file`, {
          linkFile: linkFile,
          nameFile: nameFile,
        })
        .then(async (response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          // console.log(url);
          this.haveFile = true;
          this.imgUrl = await url;
        })
        .catch((e) => {
          this.haveFile = false;
        });
    },
    getDowloadFile(linkFile, nameFile) {
      //console.log(this.Customer_Id);
      // console.log(linkFile);
      // console.log(nameFile);
      // this.dialog_doc = true;
      // console.log(this.dialog);
      this.$download_api
        .post(`/download-customer-document-file`, {
          linkFile: linkFile,
          nameFile: nameFile,
        })
        .then(async (response) => {
          console.log(response);
          // const url = window.URL.createObjectURL(new Blob([response.data]));
          // console.log(url);
          this.haveFile = true;
          // this.imgUrl = await url;
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", nameFile);
          document.body.appendChild(link);
          link.click();
        })
        .catch((e) => {
          console.log(err);
          this.haveFile = false;
        });
    },
    getListPick() {
      //console.log(this.Customer_Id);
      this.$token_api
        .get(`/download-customer-file-list/${this.Customer_Id}`)
        .then((res) => {
          // console.log(res.data.data);
          this.dataPick = res.data.data;
        })
        .catch((e) => {
          this.haveFile = false;
        });
    },
    getListDocument() {
      this.$token_api
        .get(`/download-customer-file-document-list/${this.Customer_Id}`)
        .then((res) => {
          // console.log(res.data.data);
          this.dataDocument = res.data.data;
        })
        .catch((e) => {
          this.haveFile = false;
        });
    },
    get_collecttype() {
      this.$token_api
        .get(`/type-collect-customer/${this.Customer_Id}`)
        .then((res) => {
          let get_type_collect = res.data.data[0].TYPE_COLLECT;
          this.type_collect =
            get_type_collect == "W"
              ? "เก็บรายสัปดาห์"
              : get_type_collect == "M1"
                ? "เก็บรายเดือน/1"
                : "M2";
        })
        .catch((err) => { });
    },
    openmaplink() {
      let lat = this.markers[0].lat;
      let lng = this.markers[0].lng;
      window.open(
        `https://www.google.com/maps/dir//${lat},${lng}/@${lat},${lng},11z`,
        "_blank"
      );
    },
  },
  beforeRouteEnter(to, from, next) {
    // this.previousRoute = from
    next((vm) => {
      vm.pre_route = from;
      // vm.pre_route = from
      // access to component's instance using `vm` . this is done because this navigation guard is called before the component is created.
    });
  },
};
</script>
